<p>create-campaign works!</p>
